<div id="add-compensation-container">
  <div class="item-container">
    <p class="subheading-01-semi-bold">Nombre</p>
    <div class="input-container">
      <qr-input
        id="input-normal"
        [config]="input"
        [value]="this.compensation.name"
        (valueChange)="changeName($event)"
      ></qr-input>
    </div>
    <div
      class="error-container"
      [ngClass]="{ 'error-height': this.errors.name }"
    >
      <qr-icon name="error" color="error-700"></qr-icon>
      <p class="paragraph-02-regular nomargin">
        Ingrese un nombre válido sin caracteres especiales
      </p>
    </div>
  </div>

  <div class="item-container">
    <p class="subheading-01-semi-bold">Tipo</p>
    <div class="input-container">
      <qr-toggle
        [config]="mainToggle"
        (change)="onChangeToggle($event)"
      ></qr-toggle>
    </div>
    <div id="input-percentage">
      <qr-input
        id="input-normal"
        [config]="inputNumber"
        [value]="(this.compensation.billingPercentage | number : '1.0-2') || 0"
        (valueChange)="changeNumber($event)"
        (keydown)="isValidDecimalNumber($event)"
      ></qr-input>
      <p class="caption-01-regular">porcentaje %</p>
    </div>
    <div
      class="error-container"
      [ngClass]="{ 'error-height': this.errors.number }"
    >
      <qr-icon name="error" color="error-700"></qr-icon>
      <p class="paragraph-02-regular nomargin">Ingrese un porcentaje válido</p>
    </div>
  </div>
</div>
